<template>
  <div class="works-card" @click="gotoDetail(item)">
    <div class="product-name">
      <div class="name" :title="item.name">{{ item.name }}</div>
    </div>
    <img class="works-img" :src="require('@/assets/images/展览.png')" />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    imgUrl() {
      let urls = (this.item.coverUrl || '').split(',')
      return urls[0]
    },
  },
  methods: {
    gotoDetail(item) {
      this.$emit('click', item)
    },
  },
}
</script>

<style lang="less" scoped>
.works-card {
  display: inline-block;
  cursor: pointer;
  position: relative;
  width: 245px;
  height: 170px;
  transition: transform 0.4s ease-in-out;
  background: #fff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  transition: all 0.3s;
  padding: 20px;
  .product-name {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    .name {
      font-family: PingFangSC-Semibold;
      text-align: center;
      font-size: 18px;
      width: 100%;
      padding: 0 40px;
      color: #0039a4;
      white-space: break-spaces;
      // letter-spacing: 0;
      font-weight: 600;
      // text-overflow: ellipsis;
      // overflow: hidden;
    }
  }
  .works-img {
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
    height: 170px;
  }
  &:not(:last-child) {
    margin-right: 20px;
  }
}
</style>
